export const materialsList = ['Sand','Bricks','Rabish','Gitti','Khatu','Lakdi','Murum','Soil','Stone','Cement','Rod']

export const unitList  = ["Trip", "Tons", "KG", "Meter Cube"]

const currentDate = new Date().getTime() + 24*60*60*1000
const lastMonthDate = currentDate - 2592000000
export const initialFilter = {
    driver: false,
    labour: false,
    date_from: lastMonthDate,
    date_to: currentDate,
    party: false,
    vehicle: false,
    limit_no: 50,
    start:0,
    
}
export const initialLedgerFilter = {
  date_from: lastMonthDate,
  date_to: currentDate
}
export const intitalTransactionForm = {
    date: "",
    party_name: "",
    material: "",
    quantity:0,
    quality: "",
    unit: "",
    from: "",
    to: "",
    supplier_name: "",
    vehicle: "",
    driver: "",
    labour: "",
    bill: 0,
    paid: 0,
    payment_type: "",
    book_no: "",
    slip_no: "",
    party_sig: "",
    remarks: "",
  }
  export const initialPartyForm = {
    name:"",
    mobile:"",
    address:"",
    firm:""
  }
  export const initialDriverForm = {
    name:"",
    mobile:"",
    address:"",
  }